import React, { useRef, useState, useEffect } from "react";
import useOutsideClick from "../hooks/useOutsideClick";
import { VscLock } from "react-icons/vsc";
import { Link, NavLink, useNavigate } from "react-router-dom";
// import MenuIcon from "../assetes/icons/menu.svg";
// import CloseIcon from "../assetes/icons/close.svg";
import MenuIcon from "../assetes/icons/menu.svg";
import CloseIcon from "../assetes/icons/close.svg";
import logo from "../assetes/logo-alt-removebg.png";
import logoWhite from "../assetes/flint_logo_white.jpeg";
import profile from "../assetes/icons/man.png";
import bjpLogo from "../assetes/icons/Bharatiya_Janata_Party_logo.png";
import bjpLogoWhite from "../assetes/icons/LotusFFF.svg";
import dashboard from "../assetes/icons/home.svg";
import voters from "../assetes/icons/voting-box.png";
import new_voters from "../assetes/icons/vote.png";
import reports from "../assetes/icons/report.png";
import supporters from "../assetes/icons/supporters.png";
import users from "../assetes/icons/users.png";
import birthdays from "../assetes/icons/birthday.png";
import works from "../assetes/icons/works.svg";
import electionPolls from "../assetes/icons/electionPolls.svg";
import appointments from "../assetes/icons/apppointment.svg";
import audit from "../assetes/icons/audit.svg";
import { setLocalData, shallShowTab } from "../utils/helper";
import {
  votersTabName,
  votersRoute,
  votersCallTabName,
  votersCallRoute,
  nonVotersTabName,
  nonVotersRoute,
  reportsTabName,
  reportsRoute,
  supportersTabName,
  supportersRoute,
  usersRoute,
  usersTabName,
  MODULE_VOTER,
  MODULE_VOTER_CALL,
  MODULE_NON_VOTER,
  MODULE_REPORTS,
  MODULE_SUPPORTER,
  MODULE_USERS,
  MODULE_BIRTHDAYS,
  birthdaysRoute,
  birthdaysTabName,
  MODULE_WORKS,
  worksRoute,
  worksTabName,
  voterRouteParam,
  MODULE_ELECTION_POLLS,
  electionPollsRoute,
  electionPollsTabName,
  IS_GENERIC_THEME_APP,
  dashboardRoute,
  dashboardTabName,
  MODULE_APPOINTMENTS,
  appointmentsRoute,
  appointmentsTabName,
  MODULE_HOMEPAGE,
  MODULE_AUDIT,
  auditsRoute,
  auditsTabName,
  API_URL,
  AUTH_GETCLIENTBYID
} from "../utils/constants";
import { HTTP_GET } from "../utils/services";
// import LanguageSelector from "./Translator";
import GoogleTranslateWidget from "./Translator/TranslateWidget";

const navItemClasses =
  "text-gray-900 font-semibold flex items-center px-4 py-3 w-full md:py-2 text-sm border-b";

const Header = () => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropDown] = useState(false);

  const [client, setClient] = useState({
    displayName: "",
    logo: "",
  });

  useEffect(() => {
    const fetchClient = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));

        if (!user?.clientId) {
          console.warn("ClientId not found in login data");
          return;
        }

        const response = await HTTP_GET(
          `${API_URL}${AUTH_GETCLIENTBYID}/${user.clientId}`
        );

        console.log("CLIENT API RESPONSE:", response);

        if (response?.statusCode === "OK" && response?.body) {
          setClient({
            displayName: response.body.displayName,
            logo: response.body.logo,
          });
        }
      } catch (error) {
        console.error("Client fetch error:", error);
      }
    };

    fetchClient();
  }, []);
  const logoSrc = client.logo
    ? `data:image/png;base64,${client.logo}`
    : "";


  const menu_ref = useRef();

  useOutsideClick(menu_ref, () => {
    if (showDropdown) {
      setShowDropDown(false);
    }
  });

  const handleMenuOpen = (state) => {
    setShowDropDown(state);
  };

  const onUserLogout = () => {
    localStorage.removeItem("user");
    setLocalData(null, true);
    navigate("/");
  };
  //This is generic theme for the Votersync Site Header
  // if (IS_GENERIC_THEME_APP) {
  //   return (
  //     // <div className={`flex justify-between px-3 md:px-5 bg-gradient-to-r from-[#fff] via-[#00027240] via-60%  to-[#000272b0] items-center shadow-md fixed left-0 right-0 top-0 z-[101] lg:z-[200]`}>
  //     <div className={`flex justify-between px-3 md:px-5 bg-[#ef9138] items-center shadow-md fixed left-0 right-0 top-0 z-[1123] lg:z-[200]`}>
  //       <div>
  //         <div className="text-blue-950 font-semibold text-[4vw] lg:text-[2.2rem] tracking-[1px] py-3"
  //           style={{
  //             textShadow: '1px 1px 1px white,1px 1px 1px black',
  //             fontFamily: 'tiro',
  //           }}
  //         >
  //           VoterSync
  //         </div>
  //       </div>
  //       <div className={`relative text-left flex gap-1 items-end md:items-center flex-row`}>
  //         <div>
  //           {/* <LanguageSelector /> */}
  //           <GoogleTranslateWidget
  //           />
  //         </div>
  //         <div>
  //           <span ref={menu_ref}>
  //             <img src={profile} className="hidden lg:block w-[8vw] md:w-10 cursor-pointer shadow-lg rounded-full"
  //               style={{
  //                 boxShadow: '0px 1px 17px -4px white'
  //               }}
  //               onClick={() => handleMenuOpen(true)}
  //               onMouseOver={() => handleMenuOpen(true)}

  //             />
  //             <img src={
  //               showDropdown ? CloseIcon : MenuIcon
  //             } className={`block lg:hidden w-[20px] sm:w-[30px] cursor-pointer`} onClick={() => handleMenuOpen(true)}
  //               onMouseOver={() => handleMenuOpen(true)}
  //             />
  //           </span>
  //           <div
  //             className={`absolute right-[-100px] ${showDropdown ? 'w-[23ch] h-auto opacity- right-[0]' : 'w-[50%] h-0 opacity-0 hidden-dropdown'} z-[1123] mt-2 transition-[height_position] ease-in-out origin-top-right border-[1px_solid_lightgray] rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none`}
  //             role="menu"
  //             aria-orientation="vertical"
  //             aria-labelledby="menu-button"
  //             tabIndex="-1"
  //             onMouseLeave={() => handleMenuOpen(false)}
  //           >
  //             <div className="font-semibold py-1" role="none">
  //               <span className="block lg:hidden">
  //                 {shallShowTab(MODULE_HOMEPAGE) && <NavLink
  //                   className={`${navItemClasses} flex gap-[10px]`}
  //                   end
  //                   to={dashboardRoute}
  //                 >
  //                   <img src={dashboard} className="w-5" />
  //                   {dashboardTabName}
  //                 </NavLink>}
  //                 {shallShowTab(MODULE_VOTER) && <NavLink
  //                   className={`${navItemClasses} flex gap-[10px]`}
  //                   end
  //                   to={votersRoute}
  //                 >
  //                   <img src={voters} className="w-5" />
  //                   {votersTabName}
  //                 </NavLink>}
  //                 {shallShowTab(MODULE_VOTER_CALL) && <NavLink
  //                   className={`${navItemClasses} flex gap-[10px]`}
  //                   end
  //                   to={votersCallRoute}
  //                 >
  //                   <img src={voters} className="w-5" />
  //                   {votersCallTabName}
  //                 </NavLink>}
  //                 {shallShowTab(MODULE_NON_VOTER) && <NavLink
  //                   className={`${navItemClasses} flex gap-[10px]`}
  //                   end
  //                   to={nonVotersRoute}
  //                 >
  //                   <img src={new_voters} className="w-5" />
  //                   {nonVotersTabName}
  //                 </NavLink>}
  //                 {shallShowTab(MODULE_REPORTS) && <NavLink
  //                   className={`${navItemClasses} flex gap-[10px]`}
  //                   end
  //                   to={reportsRoute}
  //                 >
  //                   <img src={reports} className="w-5" />
  //                   {reportsTabName}
  //                 </NavLink>}
  //                 {/* {shallShowTab(MODULE_SUPPORTER) && <NavLink
  //                 className={`${navItemClasses} flex gap-[10px]`}
  //                 end
  //                 to={supportersRoute}
  //               >
  //                 <img src={supporters} className="w-5" />
  //                 {supportersTabName}
  //               </NavLink>} */}
  //                 {shallShowTab(MODULE_USERS) && <NavLink
  //                   className={`${navItemClasses} flex gap-[10px]`}
  //                   end
  //                   to={usersRoute}
  //                 >
  //                   <img src={users} className="w-5" />
  //                   {usersTabName}
  //                 </NavLink>}
  //                 {shallShowTab(MODULE_BIRTHDAYS) && <NavLink
  //                   className={`${navItemClasses} flex gap-[10px]`}
  //                   end
  //                   to={`${birthdaysRoute}/${voterRouteParam}`}
  //                 >
  //                   <img src={birthdays} className="w-5" />
  //                   {birthdaysTabName}
  //                 </NavLink>}
  //                 {shallShowTab(MODULE_WORKS) && <NavLink
  //                   className={`${navItemClasses} flex gap-[10px]`}
  //                   end
  //                   to={`${worksRoute}/${voterRouteParam}`}
  //                 >
  //                   <img src={works} className="w-5" />
  //                   {worksTabName}
  //                 </NavLink>}
  //                 {shallShowTab(MODULE_ELECTION_POLLS) && <NavLink
  //                   className={`${navItemClasses} flex gap-[10px]`}
  //                   end
  //                   to={electionPollsRoute}
  //                 >
  //                   <img src={electionPolls} className="w-5" />
  //                   {electionPollsTabName}
  //                 </NavLink>}
  //                 {shallShowTab(MODULE_APPOINTMENTS) && <NavLink
  //                   className={`${navItemClasses} flex gap-[10px]`}
  //                   end
  //                   to={appointmentsRoute}
  //                 >
  //                   <img src={appointments} className="w-5" />
  //                   {appointmentsTabName}
  //                 </NavLink>}
  //                 {shallShowTab(MODULE_AUDIT) && <NavLink
  //                   className={`${navItemClasses} flex gap-[10px]`}
  //                   end
  //                   to={auditsRoute}
  //                 >
  //                   <img src={audit} className="w-5" />
  //                   {auditsTabName}
  //                 </NavLink>}
  //               </span>
  //               <form method="POST" action="#" role="none">
  //                 <button
  //                   type="submit"
  //                   className={`${navItemClasses} border-b-0`}
  //                   role="menuitem"
  //                   tabIndex="-1"
  //                   id="menu-item-3"
  //                   onClick={() => onUserLogout()}
  //                 >
  //                   <VscLock className="text-lg mr-3" /> Sign out
  //                 </button>
  //               </form>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   )
  // }

  return (
    <div
      className={`flex justify-between px-3 py-1 md:py-0 md:px-5 items-center shadow-md fixed bg-[#ef9138] left-0 right-0 top-0 z-[1123] lg:z-[200]`}
    >
      {/* <div className="flex justify-between px-3 md:px-5 items-center shadow-md fixed left-0 right-0 top-0 bg-blue-950 z-10 lg:z-[2]"> */}
      <div>
        <div
          className="text-blue-950 font-semibold text-[4vw] lg:text-[2.2rem] tracking-[1px] py-3"
          style={{
            textShadow: "1px 1px 1px white,1px 1px 1px black",
            fontFamily: "tiro",
          }}
        >
          VoterSync
        </div>
      </div>
      {/* CENTER OWNER NAME + LOGOS */}
      <div className="flex items-center gap-1 sm:gap-2 lg:gap-5">
        {logoSrc && (
          <img
            src={logoSrc}
            alt="Client Logo"
            className="w-[6vw] md:w-10 object-contain"
          />
        )}

        <span
          className="text-blue-950 font-semibold max-w-[19ch] sm:max-w-[inherit]
            text-[3.8vw] sm:max-md:text-[3.5vw] md:max-lg:text-[3.2vw]
            lg:text-[2.2rem] tracking-[1px]"
          style={{
            textShadow: "1px 1px 1px white,1px 1px 1px black",
            fontFamily: "tiro",
          }}
        >
          {client.displayName}
        </span>

        {logoSrc && (
          <img
            src={logoSrc}
            alt="Client Logo"
            className="w-[6vw] md:w-10 object-contain"
          />
        )}
      </div>

      <div
        className={`relative text-left flex gap-1 items-end md:items-center flex-col-reverse md:flex-row`}
      >
        <div>
          {/* <LanguageSelector /> */}
          <GoogleTranslateWidget />
        </div>
        <div>
          <span ref={menu_ref}>
            <img
              src={profile}
              className="hidden lg:block w-[8vw] md:w-10 cursor-pointer shadow-lg rounded-full"
              style={{
                boxShadow: "0px 1px 17px -4px white",
              }}
              onClick={() => handleMenuOpen(true)}
              onMouseOver={() => handleMenuOpen(true)}
            />
            <img
              src={showDropdown ? CloseIcon : MenuIcon}
              className={`block lg:hidden w-[20px] sm:w-[30px] cursor-pointer`}
              onClick={() => handleMenuOpen(!showDropdown)}
              onMouseOver={() => handleMenuOpen(!showDropdown)}
            />
          </span>
          <div
            className={`absolute right-0 ${showDropdown
              ? "w-[23ch] h-auto opacity-100"
              : "w-[50%] h-0 opacity-0 hidden-dropdown"
              } z-[1123] mt-2 transition-[height_position] ease-in-out origin-top-right border-[1px_solid_lightgray] rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none`}
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="menu-button"
            tabIndex="-1"
            onMouseLeave={() => handleMenuOpen(false)}
          >
            <div className="font-semibold py-1" role="none">
              <span
                className={`${showDropdown ? "pointer-events-auto" : "pointer-events-none"
                  } lg:hidden  w-[${!showDropdown ? "0" : "auto"}] lg:w-auto`}
              >
                {shallShowTab(MODULE_HOMEPAGE) && (
                  <NavLink
                    className={`${navItemClasses} flex gap-[10px]`}
                    end
                    to={dashboardRoute}
                  >
                    <img src={dashboard} className={`w-5`} />
                    {dashboardTabName}
                  </NavLink>
                )}
                {shallShowTab(MODULE_VOTER) && (
                  <NavLink
                    className={`${navItemClasses} flex gap-[10px]`}
                    end
                    to={votersRoute}
                  >
                    <img src={voters} className={`w-5`} />
                    {votersTabName}
                  </NavLink>
                )}
                {shallShowTab(MODULE_VOTER_CALL) && (
                  <NavLink
                    className={`${navItemClasses} flex gap-[10px]`}
                    end
                    to={votersCallRoute}
                  >
                    <img src={voters} className={`w-5`} />
                    {votersCallTabName}
                  </NavLink>
                )}
                {shallShowTab(MODULE_NON_VOTER) && (
                  <NavLink
                    className={`${navItemClasses} flex gap-[10px]`}
                    end
                    to={nonVotersRoute}
                  >
                    <img src={new_voters} className={`w-5`} />
                    {nonVotersTabName}
                  </NavLink>
                )}
                {shallShowTab(MODULE_REPORTS) && (
                  <NavLink
                    className={`${navItemClasses} flex gap-[10px]`}
                    end
                    to={reportsRoute}
                  >
                    <img src={reports} className={`w-5`} />
                    {reportsTabName}
                  </NavLink>
                )}
                {/* {shallShowTab(MODULE_SUPPORTER) && <NavLink
                className={`${navItemClasses} flex gap-[10px]`}
                end
                to={supportersRoute}
              >
                <img src={supporters} className={`w-5`} />
                {supportersTabName}
              </NavLink>} */}
                {shallShowTab(MODULE_USERS) && (
                  <NavLink
                    className={`${navItemClasses} flex gap-[10px]`}
                    end
                    to={usersRoute}
                  >
                    <img src={users} className={`w-5`} />
                    {usersTabName}
                  </NavLink>
                )}
                {shallShowTab(MODULE_BIRTHDAYS) && (
                  <NavLink
                    className={`${navItemClasses} flex gap-[10px]`}
                    end
                    to={`${birthdaysRoute}/${voterRouteParam}`}
                  >
                    <img src={birthdays} className={`w-5`} />
                    {birthdaysTabName}
                  </NavLink>
                )}
                {shallShowTab(MODULE_WORKS) && (
                  <NavLink
                    className={`${navItemClasses} flex gap-[10px]`}
                    end
                    to={`${worksRoute}/${voterRouteParam}`}
                  >
                    <img src={works} className={`w-5`} />
                    {worksTabName}
                  </NavLink>
                )}
                {shallShowTab(MODULE_ELECTION_POLLS) && (
                  <NavLink
                    className={`${navItemClasses} flex gap-[10px]`}
                    end
                    to={electionPollsRoute}
                  >
                    <img src={electionPolls} className={`w-5`} />
                    {electionPollsTabName}
                  </NavLink>
                )}
                {shallShowTab(MODULE_APPOINTMENTS) && (
                  <NavLink
                    className={`${navItemClasses} flex gap-[10px]`}
                    end
                    to={appointmentsRoute}
                  >
                    <img src={appointments} className={`w-5`} />
                    {appointmentsTabName}
                  </NavLink>
                )}
                {shallShowTab(MODULE_AUDIT) && (
                  <NavLink
                    className={`${navItemClasses} flex gap-[10px]`}
                    end
                    to={auditsRoute}
                  >
                    <img src={audit} className={`w-5`} />
                    {auditsTabName}
                  </NavLink>
                )}
              </span>
              <form method="POST" action="#" role="none">
                <button
                  type="submit"
                  className={`${navItemClasses} border-b-0`}
                  role="menuitem"
                  tabIndex="-1"
                  id="menu-item-3"
                  onClick={() => onUserLogout()}
                >
                  {showDropdown ? (
                    <>
                      {" "}
                      <VscLock className="text-lg mr-3" /> Sign out{" "}
                    </>
                  ) : (
                    <></>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
